import { axiosPrivate } from './axios';

/**
 * Week Schedule Service
 * Fetches week schedule data with approved requests
 */

const weekScheduleService = {
  /**
   * Get week schedule for a specific week
   * @param {String} weekStart - Optional week start date (YYYY-MM-DD)
   * @returns {Promise} API response with schedule data
   */
  getWeekSchedule: async (weekStart = null) => {
    const params = weekStart ? { weekStart } : {};
    const response = await axiosPrivate.get('/api/week-schedule', { params });
    return response.data;
  },
};

export default weekScheduleService;
